import type {CSSProperties, ReactElement} from 'react';
import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import styles from './social-media-preview-item.module.scss';

interface SocialMediaPreviewItemProps {
  id: string;
  item: ReactElement<any>;
}

export function SocialMediaPreviewItem({...props}: SocialMediaPreviewItemProps): ReactElement<any> {
  const {attributes, isDragging, listeners, setNodeRef, transform, transition} = useSortable({id: props.id});
  const style: CSSProperties = {
    opacity: isDragging ? 0 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  };
  return (
    <div className={styles.item} key={`key-design-${props.id}`} ref={setNodeRef} {...attributes} {...listeners} style={{...style}}>
      {props.item}
    </div>
  );
}
